// extracted by mini-css-extract-plugin
module.exports = {"SideMenuContainer":"SideNavMenuContainer_SideMenuContainer__2BNu6"};